var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-tabs',{staticClass:"crm-tabs",attrs:{"items":_vm.filteredTabs,"disabled":_vm.tabsDisableCond},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}}),_c(_vm.activeTab,{tag:"component",attrs:{"id":_vm.id},on:{"create-clinic":_vm.onCreateClinic}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }